import React from 'react';
import { Field } from 'formik';
import { mb } from '@nib/layout';
import styled from 'styled-components';
import Heading from '@nib-components/heading';
import { formLabelColor } from '@nib-components/theme';
import { NestedFormFields } from '../..';
import BaseFormField from '../base-form-field';
import { getGroupEventHandlerProps } from '../../util/propTypes';
import YesNoRadio from '../yes-no-radio';
import Textarea from '@nib-components/textarea';
const formName = 'preExConditionOptionalInfo';
const PreExistingConditionsQuestions = [{
  id: `${formName}-preExCancer`,
  name: `${formName}-preExCancer`,
  label: 'Cancer, tumour or blood condition?'
}, {
  id: `${formName}-preExDiabetes`,
  name: `${formName}-preExDiabetes`,
  label: 'Diabetes, high blood sugar or high urine sugar?'
}, {
  id: `${formName}-preExHeart`,
  name: `${formName}-preExHeart`,
  label: 'Heart condition or circulatory condition?'
}, {
  id: `${formName}-preExJoint`,
  name: `${formName}-preExJoint`,
  label: 'Joint, back or spine condition?'
}, {
  id: `${formName}-preExMedication`,
  name: `${formName}-preExMedication`,
  label: 'Taken medication for more than a month in the last 5 years?'
}, {
  id: `${formName}-preExMentalHealth`,
  name: `${formName}-preExMentalHealth`,
  label: 'Mental health condition?'
}, {
  id: `${formName}-preExOther`,
  name: `${formName}-preExOther`,
  label: 'Other health condition?'
}];
const FormSubHeading = styled(Heading)`
  color: ${formLabelColor};
  /* Bump up specificity */
  && {
    ${mb(6)};
  }
`;
const NestedFormFieldsStyled = styled(NestedFormFields)`
  && > * {
    ${mb(6)};
  }
`;
const PreExistingConditionOtherDesc = props => {
  return React.createElement(BaseFormField, {
    ...props
  }, React.createElement(Textarea, null));
};
const PreExistingConditionsGroup = props => {
  const {
    groupOnChangeHandlers = {},
    groupOnBlurHandlers = {},
    name = formName,
    expanded = false
  } = props;
  const eventHandlers = {
    groupOnBlurHandlers,
    groupOnChangeHandlers
  };
  const otherConditionTextAreaProps = {
    name: `${formName}-preExOtherDescription`,
    id: `${formName}-preExOtherDescription`,
    label: 'Other condition (please specify)',
    help: 'Please be as detailed as you can',
    error: 'Please enter your comments.',
    ...getGroupEventHandlerProps({
      ...eventHandlers,
      id: `${formName}-preExOtherDescription`
    })
  };
  return React.createElement(React.Fragment, null, React.createElement(NestedFormFieldsStyled, {
    id: `${name}--nestedFormFields`,
    expanded: expanded,
    showLeftBorder: false
  }, React.createElement(FormSubHeading, {
    size: 3
  }, "Have you ever had these conditions?"), PreExistingConditionsQuestions.map(preCondition => {
    return React.createElement(Field, {
      key: preCondition.id,
      name: preCondition.name,
      id: preCondition.id,
      component: YesNoRadio,
      label: preCondition.label,
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id: preCondition.id
      })
    });
  }), React.createElement(Field, {
    component: PreExistingConditionOtherDesc,
    ...otherConditionTextAreaProps
  })));
};
PreExistingConditionsGroup.defaultProps = {
  name: formName,
  expanded: false,
  groupOnChangeHandlers: {},
  groupOnBlurHandlers: {}
};
export default PreExistingConditionsGroup;